<script>
import Layout from '@layouts/main.vue'
import Footer from '@components/footer.vue'
import {
  clearSessionSearch,
  clearSessionAll,
  setSessionItem,
  setSessionSome,
} from '@utils/session.js'
import {
  areas,
  genre,
  prefectures,
  areaCode,
  DISPLAYMODE,
  areaText,
	prefectureText,
  areaCodeFromText,
  genreMainText,
  genreSubText,
	getPrefectureCodeFromAreaCode,
	getMunicipalityFromAreaCode,
  toSearchResultWithQuery,
  toMapWithQuery,
} from '@state/modules/facility-search.js'
import { JAF_NAVI_TOP, JAF_NAVI_TOP_TEST } from '@utils/link'
import { watchPosition } from '@utils/geoLocation.js'
import {
  API_SEARCH_HISTORY_AND_UPDATE,
  API_RECOMEND_SHOP_LIST,
  API_GENERAL_NOTICE_LIST,
  API_BANNER_LIST,
  API_MUNICIPALITY_LIST,
} from '@utils/api.js'
import { getClientType } from '@utils/client'
import noImg from '@img/map/noimage.png'
import arrow_L from '@img/arrow_L.png'
import * as Swiper from '@/node_modules/swiper/swiper-bundle.min.js'
import Loading from 'vue-loading-overlay'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'FacilitySearch',
  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [{ name: 'description', content: this.pageTitle }],
    }
  },
  components: { Layout, Loading, Footer },
  data() {
    return {
			showAreaMunSelectList: '',
      showArrow: true,
      isHeightLoading: false,
      isEdge: false,
      selectedGenre: false,
      selectedArea: false,
			showAreaSelectList:false,
      searchFormInfo: {
        name: '',
        genre: '',
        area: '',
      },
      modalWindowFlg: 0,
      // メニュータイトル
      menuCategory: '',
      genreMenuList: this.$store.state.genre.mainGenre,
      genreSubMenuList: [],
      areaMenuList: this.$store.state.area.areaList,
      areaButtonList: [],
      areaSubMenuList: [],
      uaType: getClientType() + 1,
      pwaModalWindowFlg: 0,
      pwaObiShow: 1,
      // エリアから検索のアコーディオン表示
      formAreaAccordion: false,
      // 条件指定検索のアコーディオン表示
      formAccordion: false,
      // ジャンル表示切替選択中
      genreSelected: false,
      // ジャンル表示切替選択中
      areaSelected: false,
      // メニューどちらを開いたか
      menuType: '',
      // メニュー表示フラグ1
      showMenu1: false,
      // メニュー表示フラグ2
      showMenu2: false,
      // 表示メニュー1
      showMenuList1: [],
      // 表示メニュー2
      showMenuList2: [],
      // キーワードデータ
      setKeyword: '',
      // PCセレクト選択
      pcSelectAreaMain: '',
			pcSelectAreaSub: '',
			pcSelectAreaMun: '',
			pcAreaSubDisabled: true,
			pcAreaMunDisabled: true,
      // PCセレクト選択
      pcSelectGanreMain: '',
      pcSelectGanreSub: '',
      pcGanreSubDisabled: true,
      jafnaviTop:
        process.env.NODE_ENV === 'production'
          ? JAF_NAVI_TOP
          : JAF_NAVI_TOP_TEST,
      DISPLAYMODE,
      // おすすめ施設
      shopRecomendResult: {},
      // 汎用お知らせ
      generalNotices: {},
      // バナー
      banners: [],
      isGASend: false,
      showCouponLogin: this.$store.state.auth && this.$store.state.auth.userType &&
      !(this.$store.state.auth.userType === '0'||this.$store.state.auth.userType === '1'||this.$store.state.auth.userType === '2'||this.$store.state.auth.userType === '3'||this.$store.state.auth.userType === '4'||this.$store.state.auth.userType === '80'),
      areaMunMenuList: {},
    }
  },
  computed: {
    pageTitle() {
      if (this.displayMode != DISPLAYMODE.CONDITION) {
        return '優待検索TOP | JAFナビ'
      } else {
        return '条件の変更 | JAFナビ'
      }
    },
    isShowShotcut() {
      return (
        this.uaType != 3 &&
        this.pwaObiShow &&
        this.$store.state.facilitySearch.displayMode == DISPLAYMODE.START &&
        document.cookie.indexOf('obiClicked') == -1 &&
        !this.isLinksMode
      )
    },
    isConditionEmpty() {
      return (
        !this.isOnline &&
        !this.isLimited &&
        !this.existCoupon &&
        !this.isPremiam &&
        !this.isNewShop &&
        (!this.genre || this.genre.length === 0) &&
        (!this.prefecture || this.prefecture.length === 0) &&
        (!this.searchWord || this.searchWord.length === 0) &&
        !this.isNowAround &&
        !this.isPointSearch
      )
    },
    isConditionGenreOnly() {
      return (
        !this.isOnline &&
        !this.isLimited &&
        !this.existCoupon &&
        !this.isPremiam &&
        !this.isNewShop &&
        (this.genre && this.genre.length !== 0) &&
        (!this.prefecture || this.prefecture.length === 0) &&
        (!this.searchWord || this.searchWord.length === 0) &&
        !this.isNowAround &&
        !this.isPointSearch
      )
    },
    isConditionAreaOnly() {
      return (
        !this.isOnline &&
        !this.isLimited &&
        !this.existCoupon &&
        !this.isPremiam &&
        !this.isNewShop &&
        (!this.genre || this.genre.length === 0) &&
        (this.prefecture && this.prefecture.length !== 0) &&
        (!this.searchWord || this.searchWord.length === 0) &&
        !this.isNowAround &&
        !this.isPointSearch
      )
    },
    areaPlaceholder() {
      if (
        this.isPointSearch &&
        this.$store.state.facilitySearch.lon > 0 &&
        this.$store.state.facilitySearch.lat > 0
      ) {
        return (
          '緯度 ' +
          this.$store.state.facilitySearch.lon +
          '・' +
          '経度 ' +
          this.$store.state.facilitySearch.lat
        )
      } else {
        return 'エリア'
      }
    },
    mainAreaSelectCss() {
      return this.pcSelectAreaMain || this.isPointSearch
    },
    isLimited: {
      get() {
        return this.$store.state.facilitySearch.tempIsLimited
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsLimited', value)
      },
    },
    isOnline: {
      get() {
        return this.$store.state.facilitySearch.tempIsOnline
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsOnline', value)
      },
    },
    localExcludeBrandFlag: {
      get() {
        if (this.isDisableInputExcludeBrandFlag) {
          return false
        }
        return this.excludeBrandFlag
      },
      set(value) {
        this.excludeBrandFlag = value
      },
    },
    isDisableInputExcludeBrandFlag() {
      // すべての検索条件が空の場合
      if (this.isConditionEmpty) {
        console.log(`all empty`)
        return true
      }

      // ジャンルのみが指定されている場合
      if (this.isConditionGenreOnly) {
        console.log(`only genre`)
        return true
      }

      // エリアに位置情報がある場合
      if (this.isNowAround || this.isPointSearch) {
        console.log(`has position`)
        return true
      }

      // エリアのみが指定されている場合
      if (this.isConditionAreaOnly) {
          console.log(`only area munic=${this.municipality} judge=${!this.municipality || this.municipality === '全域'}`)
        // 市区町村まで設定していない場合
        if (!this.municipality || this.municipality === '全域') {
          console.log(`no municipality`)
          return true
        }
      }

      return false
    },
    excludeBrandFlag: {
      get() {
        return this.$store.state.facilitySearch.excludeBrandFlag
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setExcludeBrandFlag', value)
      },
    },
    existCoupon: {
      get() {
        return this.$store.state.facilitySearch.tempExistCoupon
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempExistCoupon', value)
      },
    },
    isPointSearch: {
      get() {
        return this.$store.state.facilitySearch.tempIsPointSearch
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsPointSearch', value)
      },
    },
    isNowAround: {
      get() {
        return this.$store.state.facilitySearch.tempIsNowAround
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsNowAround', value)
      },
    },
    isPremiam: {
      get() {
        return this.$store.state.facilitySearch.tempIsPremiam
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsPremiam', value)
      },
    },
    isNewShop: {
      get() {
        return this.$store.state.facilitySearch.tempIsNewShop
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsNewShop', value)
      },
    },
    search: {
      get() {
        return this.$store.state.facilitySearch.tempIsNowAround
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempIsNowAround', value)
      },
    },
    genre: {
      get() {
        return this.$store.state.facilitySearch.tempGenre
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempGenre', value)
      },
    },
		prefecture: {
      get() {
        return this.$store.state.facilitySearch.tempPrefecture
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempPrefecture', value)
      },
    },
		municipality: {
      get() {
        return this.$store.state.facilitySearch.tempMunicipality
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setTempMunicipality', value)
      },
    },
    searchWord: {
      get() {
        return this.$store.state.facilitySearch.tempSearchWord
      },
      set(value) {
        this.searchFormInfo.name = value
        this.$store.dispatch('facilitySearch/setTempSearchWord', value)
      },
    },
    isBackToHome() {
      if (this.displayMode === DISPLAYMODE.START) {
        return true
      } else if (this.displayMode === DISPLAYMODE.CONDITION) {
        return false;
      } else if (
        sessionStorage.getItem('PRE_SCREEN_ID') == 'SU-03' ||
        sessionStorage.getItem('PRE_SCREEN_ID') == 'SU-05'
      ) {
        return false
      } else {
        return true
      }
    },
    isBackButtonDisp() {
      if (
        this.$store.state.auth.userType == '80' &&
        this.$store.state.auth.loggedIn
      ) {
        if (this.isBackToHome) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    backTitle() {
      if (this.isBackToHome) {
        return 'ホーム'
      } else {
        return '戻る'
      }
    },
    isLinksMode() {
      if (
        this.$store.state.auth.userType == '80' &&
        this.$store.state.auth.loggedIn
      ) {
        return true
      }

      return false
    },
    isBanner() {
      if (
        this.banners[0] &&
        Object.keys(this.banners[0]).length > 0
      ) {
        return true
      } else {
        return false
      }
    },
    ...mapState({
      displayMode: (state) => state.facilitySearch.displayMode,
    }),
  },
  watch:{
    isDisableInputExcludeBrandFlag() {
      // 活性 -> 非活性になったとき、「チェーン店を除く」トグルをOFFにする
      // 非活性 -> 活性になったとき、「チェーン店を除く」トグルをOFFにする
      this.excludeBrandFlag = false
    }
  },
  created() {
    this.init()
    this.areaMenuList.map((val, i) => {
      if (val.option_list != '指定しない' && val.option_list != '現在地周辺') {
        this.areaButtonList.push(val)
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    const position = document.querySelector('#jaf_container').scrollTop
    sessionStorage.setItem('POSITION', JSON.stringify(position))
    next()
  },
  mounted() {

    if (this.displayMode != DISPLAYMODE.CONDITION) {
      window.dataLayer.push({
        event: 'Webview',
        ap_screen_name: 'JAFナビ_優待検索TOP',
      })
    } else {
      window.dataLayer.push({
        event: 'Webview',
        ap_screen_name: 'JAFナビ_条件を指定して検索_条件の変更',
      })
      this.$store.dispatch('layout/endLoading')
      this.isHeightLoading = false
    }

    if (this.genre && this.genre.length > 0) {
      this.selectedGenre = true
    }
    if (
      (this.prefecture && this.prefecture.length > 0) ||
      this.isNowAround ||
      this.isPointSearch
    ) {
      this.selectedArea = true
    }

    if (navigator.userAgent.indexOf('Edge') > -1) {
      this.isEdge = true
    }
    var areaFlag = localStorage.getItem('closeAreaFlag')
    var areaScreenFlag = sessionStorage.getItem('KEEP_CLOSE')
    if (!areaFlag || !areaScreenFlag) {
      this.formAreaAccordion = true
    }
    if (areaFlag === '1') {
      localStorage.setItem('closeAreaFlag', '')
    }
    if (sessionStorage.getItem('cleanButton')) {
      if (this.displayMode != DISPLAYMODE.CONDITION) {
        this.formClear()
        sessionStorage.setItem('cleanButton', '')
      }
    }
  },
  methods: {
    sentPost(url){
      document.ssnIdForm.action = url;
      if(this.$store.state.auth.loggedIn){
        var input_data = document.getElementById("ssnidInput")
        if(!input_data){
          input_data = document.createElement('input');
          input_data.type = 'hidden';
          input_data.name = 'SsnId';
          input_data.id = 'ssnidInput';
          var parent = document.getElementById('ssnIdPostForm');
          parent.appendChild(input_data);
        }
        input_data.value = this.$store.state.auth.sessionId;
      }
      document.ssnIdForm.submit();
    },
    // お知らせ掲載開始日
    noticeStartDate(startDate){
      // 日付フォーマット変換、日本語曜日対応
      moment.locale('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
      });
      return moment(startDate).format('YYYY/MM/DD(ddd)') ;
    },
		goArea(){
      this.$router.push({ name: 'facility-area' })
    },
		goPref(){
      // 戻るボタンの時
      if (this.isBackToHome) {
        setSessionItem('PRE_SCREEN_ID', 'SU-01')
      }

      this.$router.push({
        path: '/facility-prefecture',
        query: { SHOP_AREA: areaText(this.prefecture) },
      })
    },
    goMun(){
      if (this.isBackToHome) {
        setSessionItem('PRE_SCREEN_ID', 'SU-01')
      }

      this.$router.push({
        path: '/facility-municipality',
        query: {
          SHOP_PREFECTURE: prefectureText(this.prefecture.slice(-2)),
          SHOP_AREA: areaText(this.prefecture),
        },
      })
    },
    // 新規終了優待画面へ
    goNewOld(newEnd){
      this.$router.push({
        name: 'newend-facility',
        query: {type: newEnd}
      })
    },
    setScrollHeight() {
      var heightNum = sessionStorage.getItem('POSITION')
      var screenFlag = sessionStorage.getItem('KEEP_CLOSE')
      if (heightNum && screenFlag) {
        const scrollEl = document.getElementById('jaf_container')
        scrollEl.scrollTop = sessionStorage.getItem('POSITION')
        sessionStorage.setItem('KEEP_CLOSE', '')
        sessionStorage.setItem('POSITION', '')
      }
      setTimeout(() => {
        this.isHeightLoading = false
      }, 10)
    },
    setAreaFlag() {
      if (!this.formAreaAccordion) {
        localStorage.setItem('closeAreaFlag', '1')
      } else {
        localStorage.setItem('closeAreaFlag', '')
      }
    },
    setAreaAccordion() {
      this.formAreaAccordion = !this.formAreaAccordion
      this.setAreaFlag()
    },
    getBanner() {
      var vm = this
      this.$nextTick(() => {
        if (Object.keys(this.banners[0]).length <= 1) {
          this.showArrow = false
          const swiper = new Swiper('.swiper-container', {
            loop: false,
            autoplay: false,
            on:{
              click:function(sw,evls){
                if(evls.target.id){
                  vm.toNewPage(evls.target.id)
                }else{
                  event.preventDefault()
                }
              }
            }
          })
        } else {
          const swiper = new Swiper('.swiper-container', {
            loop: true,
            mousewheelControl: false,
            keyboardControl: false,
            breakpoints: {
              // 768px以上の場合
              768: {
                slidesPerView: 1.8,
                spaceBetween: 15,
                centeredSlides: true,
                modules: 'modules',
              },
            },
            autoplay: {
              disableOnInteraction: false,
              delay: 5000,
            },
            pagination: {
              el: '.swiper-pagination',
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on:{
              click:function(sw,evls){
                if(evls.target.id){
                  vm.toNewPage(evls.target.id)
                }else{
                  event.preventDefault()
                }
              }
            }
          })
        }
      })
    },
    clearArea() {
      if (this.isOnline) {
        this.pcSelectAreaMain = ''
				this.pcSelectAreaSub = ''
				this.pcSelectAreaMun = ''
        this.selectedArea = ''
				this.prefecture = ''
				this.municipality = ''
        this.isNowAround = false
        this.selectedArea = false
        this.searchFormInfo.area = ''
				this.showAreaSelectList = false
				this.showAreaMunSelectList = false
        this.isPointSearch = false
      } else {
				this.pcAreaSubDisabled = true
				this.pcAreaMunDisabled = true
      }
    },
    lock() {
      document.documentElement.style.overflow = 'hidden'
      document.documentElement.style.position = 'fixed'
      document.body.scroll = 'no'
    },
    unLock() {
      document.documentElement.style.overflow = 'scroll'
      document.documentElement.style.position = 'relative'
      document.body.scroll = 'yes'
    },
		saveSubArea() {
      window.dataLayer.push({
        event: '条件変更_エリア選択',
        ap_screen_name: '条件変更_エリア選択',
      })
      // sessionStorage.setItem('SHOP_PREFECTURE', this.pcSelectAreaSub)
      this.searchFormInfo.area = this.pcSelectAreaMain + this.pcSelectAreaSub
      this.isNowAround = false
      this.isPointSearch = false

      if (this.pcSelectAreaSub == 'すべて') {
        this.prefecture = areaCodeFromText(this.pcSelectAreaMain)
				this.pcSelectAreaMun = ''
				this.municipality = ''
				this.pcAreaMunDisabled = true
      } else {
        for (var i in prefectures) {
          if (prefectures[i] === this.pcSelectAreaSub) {
            this.prefecture = i
          }
        }
        this.pcSelectAreaMun = '全域'
        this.municipality = ''
        this.initMunArea(true)
      }
    },
    saveMunArea(notInt = true) {
      if (notInt) {
        this.searchFormInfo.area = this.pcSelectAreaMain + this.pcSelectAreaSub + this.pcSelectAreaMun
        this.isNowAround = false
        this.isPointSearch = false
      }

      // 条件変更画面から遷移した場合
      if (!this.areaMunMenuList || Object.keys(this.areaMunMenuList).length === 0) {
        this.municipality = this.pcSelectAreaMun
      } else {
        const flgMunExist = Object.values(this.areaMunMenuList).includes(this.pcSelectAreaMun)
        if (flgMunExist) {
          // 前回選択した市区町村が存在する場合
          this.municipality = this.pcSelectAreaMun
        } else {
          // 前回選択した市区町村が存在しない場合
          if (this.pcSelectAreaMun.length === 0) {
            this.municipality = this.pcSelectAreaMun
          } else {
            this.pcSelectAreaMun = '全域'
            this.municipality = '全域'
          }
        }
      }
    },
    initSubArea() {
      this.areaSubMenuList = this.$store.state.area.prefectureList.filter(
          (item) => {
            return item.area != '' && item.area === this.pcSelectAreaMain
          }
      )
    },
    initMunArea(notInit = true) {
      if (this.pcSelectAreaSub === '') {
        this.areaMunMenuList = {}

        if (notInit) {
          this.pcAreaMunDisabled = true
        }
        this.saveMunArea(notInit)
      } else {
        // 初期化
        var municipalityList = []
        var params = {}
        params.session_id = this.$store.state.auth.sessionId
        var formData = new FormData();
        for (var k in params) {
          formData.append(k, params[k] ?? "");
        }

        this.areaMunMenuList = {}
        this.$.post(API_MUNICIPALITY_LIST, formData)
            .then((response) => {
              if (response.data.status_code === '00' && response.data.prefecture) {
                municipalityList = response.data.prefecture

                const _pcSelectAreaSub = this.pcSelectAreaSub == 'すべて' ? '北海道' : this.pcSelectAreaSub
                const listBase = this.filterObject(municipalityList, (val, key) => {
                  return val.prefecturename === _pcSelectAreaSub
                })
                this.areaMunMenuList = listBase[Object.keys(listBase)[0]].municipality
              } else {
                this.areaMunMenuList = {}
              }

              if (notInit) {
                this.pcAreaMunDisabled = false
              }
              this.saveMunArea(notInit)
            })
            .catch(() => {
            })
      }
    },
    filterObject(obj, callback) {
      return Object.fromEntries(
          Object.entries(obj).filter(([key, val]) => callback(val, key))
      )
    },
    setArea(mainArea, cleanFlag) {
      window.dataLayer.push({
        event: 'エリアから探す_' + mainArea,
        ap_screen_name: 'JAFナビ_エリアから探すボタン_' + mainArea + '押下',
      })
      this.formClear()
      this.isNowAround = false
      this.isPointSearch = false
      this.searchFormInfo.area = mainArea + 'すべて'
			this.prefecture = areaCodeFromText(mainArea)
			this.municipality = ''
      this.shopSearch()
      if (cleanFlag) {
        this.browserBack()
      }
    },
    setSubArea() {
      this.initSubArea()
      // session data
      // sessionStorage.removeItem('LON')
      // sessionStorage.removeItem('LAT')
      if (!this.pcSelectAreaMain) {
        // sessionStorage.removeItem('SHOP_AREA')
        this.pcAreaSubDisabled = true
        this.pcAreaMunDisabled = true
      } else if (this.pcSelectAreaMain === '指定しない') {
        // sessionStorage.removeItem('SHOP_AREA')
        // sessionStorage.removeItem('NOW_AROUND')
        // sessionStorage.removeItem('POINT_SEARCH')
        // sessionStorage.removeItem('LON')
        // sessionStorage.removeItem('LAT')
        this.pcSelectAreaSub = ''
        this.pcSelectAreaMun = ''
        this.isNowAround = false
        this.isPointSearch = false
        this.prefecture = ''
        this.municipality = ''
        this.searchFormInfo.area = this.pcSelectAreaMain
        this.pcAreaSubDisabled = true
        this.pcAreaMunDisabled = true
      } else if (this.pcSelectAreaMain === '現在地周辺') {
        // sessionStorage.setItem('SHOP_AREA', this.pcSelectAreaMain)
        this.searchFormInfo.area = this.pcSelectAreaMain
        this.pcSelectAreaSub = ''
        this.pcSelectAreaMun = ''
        // sessionStorage.removeItem('POINT_SEARCH')
        // sessionStorage.removeItem('SHOP_AREA')
        // sessionStorage.removeItem('LON')
        // sessionStorage.removeItem('LAT')
        this.prefecture = ''
        this.municipality = ''
        this.isNowAround = true
        this.isPointSearch = false
        this.pcAreaSubDisabled = true
        this.pcAreaMunDisabled = true
      } else {
        // sessionStorage.setItem('SHOP_AREA', this.pcSelectAreaMain)
        this.isNowAround = false
        this.isPointSearch = false
        this.pcAreaSubDisabled = false
        this.pcAreaMunDisabled = true
        // if (this.areaSubMenuList.length > 0) {
        this.pcSelectAreaSub = 'すべて'
        this.pcSelectAreaMun = ''
        this.saveSubArea()
        // }
      }
    },
    saveSubgenre() {
      window.dataLayer.push({
        event: '条件変更_ジャンル選択',
        ap_screen_name: '条件変更_ジャンル選択',
      })
    // sessionStorage.setItem('SHOP_SUB_GENRE', this.pcSelectGanreSub)
      this.searchFormInfo.genre = genreMainText(this.pcSelectGanreMain)
      if (this.pcSelectGanreSub) {
        this.searchFormInfo.genre += ' ' + genreSubText(this.pcSelectGanreSub)

        if (this.pcSelectGanreSub == 'すべて') {
          this.genre = this.pcSelectGanreMain
        } else {
          this.genre = this.pcSelectGanreSub
        }
      } else {
        this.pcSelectGanreMain
      }
    },
    initSubgenre() {
      this.genreSubMenuList = this.$store.state.genre.genreList.filter(
        (item) => {
          return item.genrecode === this.pcSelectGanreMain
        }
      )
      if (this.genreSubMenuList.length > 0) {
        this.pcGanreSubDisabled = false
      } else {
        this.pcGanreSubDisabled = true
        // sessionStorage.removeItem('SHOP_SUB_GENRE')
        this.pcSelectGanreSub = ''
      }
    },
    setSubgenre() {
      this.initSubgenre()

      // sessionStorage.removeItem('SHOP_SUB_GENRE')

      // save genre to session
      if (this.pcSelectGanreMain === '1') {
        // sessionStorage.removeItem('SHOP_MAIN_GENRE')
        this.pcSelectGanreSub = ''
        this.genre = ''
        this.searchFormInfo.genre = genreMainText(this.pcSelectGanreMain)
      } else {
        // sessionStorage.setItem('SHOP_MAIN_GENRE', this.pcSelectGanreMain)
        if (this.genreSubMenuList.length > 0) {
          this.pcSelectGanreSub = 'すべて'
        }
        this.genre = this.pcSelectGanreMain
        this.saveSubgenre()
      }
    },
    removeSessionItemFromNavBar() {
      sessionStorage.removeItem('AREA')
      sessionStorage.removeItem('BRAND_ID')
      sessionStorage.removeItem('cleanButton')
      sessionStorage.removeItem('COUPON_FLAG')
      sessionStorage.removeItem('DISPLAY_MODE')
      sessionStorage.removeItem('GENRE')
      sessionStorage.removeItem('KEEP_CLOSE')
      sessionStorage.removeItem('LAT')
      sessionStorage.removeItem('LON')
      sessionStorage.removeItem('NEW_FLAG')
      sessionStorage.removeItem('NOW_AROUND')
      sessionStorage.removeItem('POINT_SEARCH')
      sessionStorage.removeItem('POSITION')
      sessionStorage.removeItem('PRE_SCREEN_ID')
      sessionStorage.removeItem('PREMIAM_FLAG')
      sessionStorage.removeItem('SEARCH_TAG_ID')
      sessionStorage.removeItem('SEARCH_WORD')
      sessionStorage.removeItem('TEMP_COUPON_FLAG')
      sessionStorage.removeItem('TEMP_GENRE')
      sessionStorage.removeItem('TEMP_MUNICIPALITY')
      sessionStorage.removeItem('TEMP_NEW_FLAG')
      sessionStorage.removeItem('TEMP_NOW_AROUND')
      sessionStorage.removeItem('TEMP_POINT_SEARCH')
      sessionStorage.removeItem('TEMP_PREFECTURE')
      sessionStorage.removeItem('TEMP_PREMIAM_FLAG')
      sessionStorage.removeItem('TEMP_SEARCH_WORD')
      sessionStorage.removeItem('TEMP_WEB_FLAG')
      sessionStorage.removeItem('TEMP_YUUTAI_FLAG')
      sessionStorage.removeItem('WEB_FLAG')
      sessionStorage.removeItem('YUUTAI_FLAG')
      sessionStorage.removeItem('index')
      sessionStorage.removeItem('ZOOM')
      sessionStorage.removeItem('DIST')
      sessionStorage.removeItem('EXCLUDE_BRAND_FLAG')
    },
    init() {
      console.log("@@@ init")
      // グローバルナビゲーションからの遷移の場合
      if(this.$route.query.from_navigation === "1") {
        // 画面モードを初期表示モードに切り替える
        this.$store.dispatch('facilitySearch/setDisplayMode',DISPLAYMODE.START)
        // セッションを初期化する
        this.removeSessionItemFromNavBar()
        // 検索条件をクリアする
        this.formClear()
      }

      sessionStorage.removeItem('SHOP')
      sessionStorage.removeItem('MAP_SHOP')
      sessionStorage.removeItem('SORT')

      if (this.$route.params.clear != undefined) {
        clearSessionSearch()
        this.$store.dispatch('facilitySearch/clearSearch')
      }

      if (this.$route.params.area != undefined) {
        if (this.$route.params.area == '') {
					this.prefecture = ''
					this.municipality = ''
          this.isNowAround = false
          this.isPointSearch = false
          this.searchFormInfo.area = 'エリア'
        } else if (this.$route.params.area == '現在地周辺') {
					this.prefecture = ''
					this.municipality = ''
          this.isNowAround = true
          this.isPointSearch = false
          this.searchFormInfo.area = '現在地周辺'
        } else {
					let isArea = false
					let isMunicipality = false

					if (this.$route.params.municipality != undefined) {
						if (this.$route.params.municipality == '') {
							this.municipality = ''
						} else {
							this.municipality = this.$route.params.municipality
							isMunicipality = true
					}
				}

					if (!isMunicipality) {
	          for (var i in areas) {
	            if (areas[i].name === this.$route.params.area) {
	              const area = areas[i].code
	              this.prefecture = areas[i].code
	              this.isNowAround = false
	              this.isPointSearch = false
	              isArea = true
	            }
						}
					}

          if (!isArea) {
            for (var i in prefectures) {
              if (prefectures[i] === this.$route.params.area) {
                const area = areaCode(i)
                this.prefecture = i
                this.isNowAround = false
                this.isPointSearch = false
              }
            }
          }
        }
      }

      if (this.$route.params.genre != undefined) {
        if (this.$route.params.genre == '') {
          this.genre = ''
          this.pcSelectGanreMain = ''
          this.pcSelectGanreSub = ''
          this.searchFormInfo.genre = 'ジャンル'
        } else {
          this.genre = this.$route.params.genre
        }
      }

      if (this.genre && this.genre.length > 0) {
        this.pcSelectGanreMain = this.genre.slice(0, 1)

        if (this.genre.length > 1) {
          this.pcSelectGanreSub = this.genre
        } else {
          this.pcSelectGanreSub = 'すべて'
        }
      }

      // if selected pc  genre
      // this.pcSelectGanreMain =
      //   sessionStorage.getItem('SHOP_MAIN_GENRE') === null
      //     ? ''
      //     : sessionStorage.getItem('SHOP_MAIN_GENRE')
      this.initSubgenre()
      // this.pcSelectGanreSub =
      //   sessionStorage.getItem('SHOP_SUB_GENRE') === null
      //     ? ''
      //     : sessionStorage.getItem('SHOP_SUB_GENRE')

      // if inputed name
      // var NAME =
      //   sessionStorage.getItem('SEARCH_WORD') === null
      //     ? ''
      //     : sessionStorage.getItem('SEARCH_WORD')

      // show in phone
      // if (NAME) {
      //   this.searchFormInfo.name = NAME
      // }
      this.searchFormInfo.genre = genreMainText(this.pcSelectGanreMain)
      if (this.pcSelectGanreSub) {
        this.searchFormInfo.genre += ' ' + genreSubText(this.pcSelectGanreSub)
      }

      // 汎用お知らせデータ取得
      this.requestGeneralNoticeData()
      // バナーデータ取得
      this.requestBannerData()

      var LAT = sessionStorage.getItem('LAT')
      var LON = sessionStorage.getItem('LON')
      var NOW_AROUND = sessionStorage.getItem('NOW_AROUND')

      // オススメ施設データ取得
      this.requestShopListRecomendData(LAT, LON)

      // if selected pc  area
      this.pcSelectAreaMain =
        this.prefecture == '' ? '' : areaText(this.prefecture)
      this.initSubArea()
      if (this.prefecture.length > 0) {
				this.pcAreaSubDisabled = false
      }
			if (this.prefecture.length == 3) {
				this.pcSelectAreaSub =
					this.municipality.length > 0 ? '北海道' : 'すべて'
      } else {
        this.pcSelectAreaSub =
          this.prefecture == '' ? '' : prefectures[this.prefecture]
      }
      this.initMunArea(false)
			if (this.municipality.length > 0) {
				this.pcAreaMunDisabled = false
			}
			if (this.municipality == 'すべて' || this.municipality == '全域') {
				// this.municipality == 'すべて' はPC版用
				// this.municipality == '全域' 　はSP版用
        this.pcSelectAreaMun = '全域'
      } else {
				this.pcSelectAreaMun =
          this.municipality == '' ? '' : this.municipality
			}

      if (
        (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-03' ||
          sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-05') &&
        this.prefecture.length == 0 &&
        this.isPointSearch
      ) {
        this.searchFormInfo.area = '緯度 ' + LAT + '・' + '経度 ' + LON
        // TODO: '緯度 経度 表示'
        // this.pcSelectAreaMain = '緯度 ' + LAT + '・' + '経度 ' + LON
				this.pcSelectAreaSub = ''
				this.pcSelectAreaMun = ''
      } else if (this.isNowAround) {
        this.searchFormInfo.area = '現在地周辺'
        this.pcSelectAreaMain = '現在地周辺'
        this.pcSelectAreaSub = ''
				this.pcSelectAreaMun = ''
      } else {
        this.searchFormInfo.area =
          this.pcSelectAreaMain + this.pcSelectAreaSub + this.pcSelectAreaMun
            ? this.pcSelectAreaMain + this.pcSelectAreaSub + this.pcSelectAreaMun
            : 'エリア'
      }

      if (this.displayMode != DISPLAYMODE.START) {
        this.formAccordion = true
      }

      if (!this.isConditionEmpty) {
        this.formAccordion = true
      }
      // this.searchFormInfo.existCoupon = COUPON_FLAG
    },
    online() {
      window.dataLayer.push({
        event: 'オンライン優待施設',
        ap_screen_name: 'JAFナビ_オンライン優待施設ボタン押下',
      })
      this.formClear()
      this.isOnline = true
      this.shopSearch()
      this.browserBack()
    },
    shopSearch() {
      if (this.isConditionEmpty) {
        this.$store.dispatch('layout/endLoading')
        this.$popup({
          text: '条件を入力してください。',
        })
        return
      }
      this.$store.dispatch('layout/startLoading')
      event.preventDefault()
      sessionStorage.removeItem('GENRE')
      sessionStorage.removeItem('AREA')
      sessionStorage.removeItem('NOW_AROUND')
      sessionStorage.removeItem('DIST')
      if (this.isLimited) {
        this.$store.dispatch('facilitySearch/checkIsLimited')
      } else {
        this.$store.dispatch('facilitySearch/uncheckIsLimited')
      }
      if (this.existCoupon) {
        this.$store.dispatch('facilitySearch/checkCoupon')
      } else {
        this.$store.dispatch('facilitySearch/uncheckCoupon')
      }
      if (this.isOnline) {
        this.$store.dispatch('facilitySearch/checkIsOnline')
      } else {
        this.$store.dispatch('facilitySearch/uncheckIsOnline')
      }
      if (this.isPremiam) {
        this.$store.dispatch('facilitySearch/checkIsPremiam')
      } else {
        this.$store.dispatch('facilitySearch/uncheckIsPremiam')
      }
      if (this.isNewShop) {
        this.$store.dispatch('facilitySearch/checkIsNewShop')
      } else {
        this.$store.dispatch('facilitySearch/uncheckIsNewShop')
      }
      this.$store.dispatch('facilitySearch/setExcludeBrandFlag', this.localExcludeBrandFlag)
      this.$store.dispatch('facilitySearch/setIsNowAround', this.isNowAround)
      this.$store.dispatch(
        'facilitySearch/setIsPointSearch',
        this.isPointSearch
      )
      this.$store.dispatch('facilitySearch/setAreaCode', '')
      this.saveForName()
      const params = {}
      params.session_id = this.$store.state.auth.sessionId
      params.type = 1
      params.SEARCH_WORD = this.searchWord
      var GENRE = this.genre
      sessionStorage.setItem('GENRE', GENRE)
      this.$store.dispatch('facilitySearch/setGenreCode', GENRE)
      var AREA = ''
      if (
        !(
          this.searchFormInfo.area === 'エリア' ||
          this.searchFormInfo.area === 'すべて' ||
          this.searchFormInfo.area === '現在地周辺'
        ) &&
        this.searchFormInfo.area.indexOf('緯度') === -1
      ) {
        // sessionStorage.removeItem('LAT')
        // sessionStorage.removeItem('LON')
				if (this.prefecture != '') {
          if (this.prefecture.length == 3) {
            AREA = this.prefecture
          } else {
						const area = areaCode(this.prefecture)
						if (this.municipality != '' && this.municipality.length > 0) {
							AREA = area + ' ' + this.prefecture + ' ' + this.municipality
						} else {
							AREA = area + ' ' + this.prefecture
						}
          }

          // sessionStorage.setItem('SHOP_AREA', areaText(this.prefecture))
          // sessionStorage.setItem(
          //   'SHOP_PREFECTURE',
          //   prefectures[this.prefecture]
          // )
          this.$store.dispatch('facilitySearch/setAreaCode', AREA)
        }
      }
      if (this.searchFormInfo.area === '現在地周辺') {
        watchPosition()
          .then((res) => {
            params.LONGITUDE = res.longitude
            params.LATITUDE = res.latitude
          })
          .catch(({ result, code }) => {
            console.log(code)
            params.LONGITUDE = '0.0'
            params.LATITUDE = '0.0'

            if (code == 1) {
              this.$popup({
                text:
                  '位置情報の取得に失敗しました。</br>現在地を表示するには、端末の位置情報サービスをオンにしてください。',
              })
            } else {
              this.$popup({
                text:
                  '位置情報の取得に失敗しました。</br>場所を変えてもう一度お試しください。',
              })
            }
          })
          .finally(() => {
            if (!(params.LONGITUDE === '0.0' && params.LATITUDE === '0.0')) {
              sessionStorage.setItem('LON', params.LONGITUDE)
              sessionStorage.setItem('LAT', params.LATITUDE)
              sessionStorage.setItem('NOW_AROUND', '1')
              this.$store.dispatch('facilitySearch/setIsNowAround', true)
              this.$store.dispatch('facilitySearch/setIsPointSearch', false)
              sessionStorage.setItem('DIST', '1')
              sessionStorage.setItem('SORT', '2')
              this.requestResult(params, AREA, GENRE)
            } else {
              sessionStorage.removeItem('LON')
              sessionStorage.removeItem('LAT')
              sessionStorage.removeItem('NOW_AROUND')
              sessionStorage.removeItem('POINT_SEARCH')
              this.$store.dispatch('facilitySearch/setIsNowAround', false)
              this.$store.dispatch('facilitySearch/setIsPointSearch', false)
              sessionStorage.removeItem('DIST')
              this.$store.dispatch('layout/endLoading')
            }
          })
      } else if (!this.$store.state.facilitySearch.isNowAround) {
        this.requestResult(params, AREA, GENRE)
      }
    },

    requestResult(params, AREA, GENRE) {
      sessionStorage.setItem('AREA', AREA)
      params.GENRE = GENRE
      params.AREA = AREA
      if (this.isNowAround) {
        params.NOW_AROUND = '1'
      }
      params.COUPON_FLAG = 0
      sessionStorage.setItem('COUPON_FLAG', '')
      if (this.existCoupon) {
        sessionStorage.setItem('COUPON_FLAG', '1')
      }
      params.WEB_FLAG = 0
      sessionStorage.setItem('WEB_FLAG', '')
      if (this.isOnline) {
        sessionStorage.setItem('WEB_FLAG', '1')
      }
      params.YUUTAI_FLAG = 0
      sessionStorage.setItem('YUUTAI_FLAG', '')
      if (this.isLimited) {
        sessionStorage.setItem('YUUTAI_FLAG', '1')
      }
      params.PREMIAM_FLAG = 0
      sessionStorage.setItem('PREMIAM_FLAG', '')
      if (this.isPremiam) {
        sessionStorage.setItem('PREMIAM_FLAG', '1')
      }
      params.NEW_FLAG = 0
      sessionStorage.setItem('NEW_FLAG', '')
      if (this.isNewShop) {
        sessionStorage.setItem('NEW_FLAG', '1')
      }
      this.$store.dispatch('layout/endLoading')
      if (this.isPointSearch) {
        this.$route.meta.isBack = false
        sessionStorage.setItem('DIST', '1')
        this.$store.dispatch('layout/disableMapAlive')
        toMapWithQuery()
      } else if (this.isNowAround) {
        this.$route.meta.isBack = false
        sessionStorage.setItem('DIST', '1')
        toSearchResultWithQuery()
      } else {
        sessionStorage.removeItem('LAT')
        sessionStorage.removeItem('LON')
        this.$route.meta.isBack = false
        toSearchResultWithQuery()
      }
    },
    formClear() {
      if (event) {
        event.preventDefault()
      }
      // clearSessionSearch()
			this.showAreaSelectList = false
			this.showAreaMunSelectList = false
      this.pcSelectAreaMain = ''
			this.pcSelectAreaSub = ''
			this.pcSelectAreaMun = ''
      this.pcSelectGanreMain = ''
      this.pcSelectGanreSub = ''
			this.pcAreaSubDisabled = true
			this.pcAreaMunDisabled = true
      this.pcGanreSubDisabled = true
      this.searchFormInfo.name = ''
      this.searchFormInfo.genre = 'ジャンル'
      this.searchFormInfo.area = 'エリア'
      // this.$store.dispatch('facilitySearch/clearSearch')
      this.isOnline = false
      this.isLimited = false
      this.existCoupon = false
      this.isPremiam = false
      this.isNewShop = false
      this.isNowAround = false
      this.isPointSearch = false
      this.prefecture = ''
			this.municipality = ''
      this.genre = ''
      this.searchWord = ''
      this.selectedGenre = false
      this.selectedArea = false
    },
    modalClose() {
      this.modalWindowFlg = 0
    },
    modalOpen() {
      this.modalWindowFlg = 1
    },
    pwaModalOpen() {
      window.dataLayer.push({
        event: 'ホーム画面にショートカット追加　押下',
        ap_screen_name: 'JAFナビ_ホーム画面にショートカット追加押下',
      })
      this.lock()
      this.pwaModalWindowFlg = 1
      var cookieDate = new Date()
      cookieDate.setFullYear(cookieDate.getFullYear() + 1)
      document.cookie =
        'obiClicked=1; expires=' + cookieDate.toUTCString() + ';'
    },
    pwaModalClose() {
      this.unLock()
      this.pwaModalWindowFlg = 0
    },
    pwaObiClose() {
      this.pwaObiShow = 0
    },
    stopEvent() {
      event.stopPropagation()
    },
    selectViewMenu(i) {
      if (i === 'genre') {
        window.dataLayer.push({
          event: '条件変更_ジャンル選択',
          ap_screen_name: '条件変更_ジャンル選択',
        })
        this.$router.push({ name: 'genre' })
      } else if (i === 'area') {
        window.dataLayer.push({
          event: '条件変更_エリア選択',
          ap_screen_name: '条件変更_エリア選択',
        })
        if (this.isOnline) {
        } else {
					// エリア選択リストが開いた時
					if(this.showAreaSelectList){
						this.showAreaSelectList = false
						return;
					}
					if(sessionStorage.getItem("TEMP_PREFECTURE")){
						this.showAreaSelectList = true
						if(sessionStorage.getItem("TEMP_MUNICIPALITY")){
							this.showAreaMunSelectList = true
						}
					}else{
						this.$router.push({ name: 'facility-area' })
					}
        }
      }
      this.setAreaFlag()
    },
    saveForName() {
      sessionStorage.setItem('SEARCH_WORD', this.searchWord)
      this.$store.dispatch('facilitySearch/setSearchWord', this.searchWord)
    },
    getNameOrCode(data, value, type) {
      if (type === 'getName') {
        for (var i = 0; i < data.length; i++) {
          if (data[i].code === value) {
            return data[i].name
          }
        }
      }
      if (type === 'getCode') {
        for (var j = 0; j < data.length; j++) {
          if (data[j].name === value) {
            return data[j].code
          }
        }
      }
      return ''
    },
    genreText(genreCode) {
      let result = null

      if (genreCode && genreCode.length > 1) {
        result =
          this.getNameOrCode(genre, genreCode.slice(0, 1), 'getName') +
          ' ' +
          this.getNameOrCode(genre, genreCode, 'getName')
      } else if (genreCode && genreCode.length > 0) {
        result = this.getNameOrCode(genre, genreCode, 'getName')

        if (
          ![
            '温泉・入浴施設',
            '道の駅',
            'SA・PA（サービスエリア）',
          ].includes(result)
        ) {
          result = result + ' すべて'
        }
      }

      return result
    },
    browserBack() {
      sessionStorage.setItem('cleanButton', '1')
      this.searchFormInfo.area = 'エリア'
			this.pcAreaSubDisabled = true
			this.pcAreaMunDisabled = true
    },
    toMap() {
      this.browserBack()
      this.$store.dispatch('layout/startLoading')
      window.dataLayer.push({
        event: '現在地から検索',
        ap_screen_name: 'JAFナビ_現在地から検索するボタン押下',
      })

      const position = {}
      watchPosition()
        .then((res) => {
          position.LON = res.longitude
          position.LAT = res.latitude
        })
        .catch(({ result, code }) => {
          console.log(code)
          position.LON = '0.0'
          position.LAT = '0.0'

          if (code == 1) {
            this.$popup({
              text:
                '位置情報の取得に失敗しました。</br>現在地を表示するには、端末の位置情報サービスをオンにしてください。',
            })
          } else {
            this.$popup({
              text:
                '位置情報の取得に失敗しました。</br>場所を変えてもう一度お試しください。',
            })
          }
        })
        .finally(() => {
          if (!(position.LAT === '0.0' && position.LON === '0.0')) {
            this.formClear()
            this.$store.dispatch('facilitySearch/clearSearch')
            setSessionSome(position)
            this.$store.dispatch('facilitySearch/setIsNowAround', true)
            this.isNowAround = true
            setSessionItem('DIST', '1')
            setSessionItem('SORT', '2')
            // this.$store.dispatch('layout/endLoading')
            this.$route.meta.isBack = false
            // this.$store.dispatch('layout/disableMapAlive')
            toMapWithQuery()
          } else {
            this.$store.dispatch('facilitySearch/setIsNowAround', false)
            this.isNowAround = false
            sessionStorage.removeItem('LON')
            sessionStorage.removeItem('LAT')
            this.$store.dispatch('layout/endLoading')
          }
          // 非同期で戻ってきたタイミングでmapに遷移
        })
    },
    backHandler() {
      this.resetSearch()
      // TODO: 戻るフラグチェック
      if (this.displayMode == DISPLAYMODE.START) {
        window.location.href = this.jafnaviTop
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-05') {
        this.$route.meta.isBack = true
        toSearchResultWithQuery()
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-03') {
        this.$route.meta.isBack = true
        toMapWithQuery()
      } else {
        window.location.href = this.jafnaviTop
        // this.$route.meta.isBackToCoupon = true
        // this.$router.go(-1)
      }
    },
    resetSearch() {
      this.isLimited = this.$store.state.facilitySearch.isLimited
      this.isOnline = this.$store.state.facilitySearch.isOnline
      this.existCoupon = this.$store.state.facilitySearch.existCoupon
      this.isPremiam = this.$store.state.facilitySearch.isPremiam
      this.isNewShop = this.$store.state.facilitySearch.isNewShop

      this.isNowAround = this.$store.state.facilitySearch.isNowAround
      this.isPointSearch = this.$store.state.facilitySearch.isPointSearch

			this.prefecture = getPrefectureCodeFromAreaCode(
        this.$store.state.facilitySearch.areaCode
      )
			this.municipality = getMunicipalityFromAreaCode(
        this.$store.state.facilitySearch.areaCode
      )

      this.genre = this.$store.state.facilitySearch.genreCode
      this.searchWord = this.$store.state.facilitySearch.searchWord
    },
    isMobile() {
      return window.innerWidth < 768
    },
    combineUrl(url) {
      return url
        ? this.$store.getters['env/apiBase'] +
            '/images/ph' +
            (Array(9 - url.length).join('0') + url).substring(-9 + url.length) +
            '.jpg'
        : noImg
    },
    defaultAvatar() {
      return 'this.src ="' + noImg + '"'
    },
    requestShopListRecomendData(lat, lon) {
      this.isHeightLoading = true
      var params = {}
      params.session_id = this.$store.state.auth.sessionId

      if (lat == '' || lon == '' || lat == null || lon == null) {
        watchPosition()
          .then((res) => {
            params.LONGITUDE = res.longitude
            params.LATITUDE = res.latitude

            var isMobile = this.isMobile() // モバイルかチェック

            var formData = new FormData();
            for (var k in params) {
              formData.append(k, params[k] ?? "");
            }

            // オススメ施設API呼び出し
            this.$.post(API_RECOMEND_SHOP_LIST, formData)
              .then((response) => {
                if (
                  response.data.status_code === '00' &&
                  response.data.recomends
                ) {
                  this.shopRecomendResult = response.data.recomends
                  // PC版は2件表示
                  if (!isMobile) {
                    delete this.shopRecomendResult[2]
                  }
                } else {
                  this.shopRecomendResult = {}
                }
                this.afterInit = true
                this.$nextTick(() => {
                  this.setScrollHeight()
                })
              })
              .catch(() => {})
          })
          .catch(() => {
            var isMobile = this.isMobile() // モバイルかチェック

            var formData = new FormData();
            for (var k in params) {
              formData.append(k, params[k] ?? "");
            }

            // オススメ施設API呼び出し
            this.$.post(API_RECOMEND_SHOP_LIST, formData)
              .then((response) => {
                if (
                  response.data.status_code === '00' &&
                  response.data.recomends
                ) {
                  this.shopRecomendResult = response.data.recomends
                  // PC版は2件表示
                  if (!isMobile) {
                    delete this.shopRecomendResult[2]
                  }
                } else {
                  this.shopRecomendResult = {}
                }
                this.afterInit = true
                this.$nextTick(() => {
                  this.setScrollHeight()
                })
              })
              .catch(() => {})
          })
          .finally(() => {})
      } else {
        params.LONGITUDE = lon
        params.LATITUDE = lat

        var isMobile = this.isMobile() // モバイルかチェック

        var formData = new FormData();
        for (var k in params) {
          formData.append(k, params[k] ?? "");
        }

        // オススメ施設API呼び出し
        this.$.post(API_RECOMEND_SHOP_LIST, formData)
          .then((response) => {
            if (response.data.status_code === '00' && response.data.recomends) {
              this.shopRecomendResult = response.data.recomends
              // PC版は2件表示
              if (!isMobile) {
                delete this.shopRecomendResult[2]
              }
            } else {
              this.shopRecomendResult = {}
            }
            this.$nextTick(() => {
              this.setScrollHeight()
            })
            this.afterInit = true
          })
          .catch(() => {})
      }
    },
    shopldShowRecomendList() {
      if (
        !this.afterInit ||
        (this.shopRecomendResult &&
          Object.keys(this.shopRecomendResult).length > 0)
      ) {
        return true
      } else {
        return false
      }
    },
    facilityUrl(shopId) {
        var url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(
        decodeURI(`https://${location.host}/facility-detail/${shopId}`)
      )}`
      return url
    },
    discount(facility) {
      var discount = ''
      if (facility.WB_NAIYO1) {
        discount = discount + facility.WB_NAIYO1
      }
      if (facility.WB_HANNI1) {
        discount = discount + facility.WB_HANNI1
      }
      var GAKURITU = '';
      if (facility.WB_GAKURITU1) {
        GAKURITU = facility.WB_GAKURITU1
        if (facility.WB_NAIYO1) {
          var gakuritsu = facility.WB_GAKURITU1
          if (facility.WB_TANIKU1 === '1') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*%.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = facility.WB_GAKURITU1 + '％割引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引き」を付与
                GAKURITU = facility.WB_GAKURITU1 + '割引'
              }
            }
          }
          if (facility.WB_TANIKU1 === '2') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*円.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = facility.WB_GAKURITU1 + '円引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引き」を付与
                GAKURITU = facility.WB_GAKURITU1 + '引'
              }
            }
          }
        }
      }
      return discount + GAKURITU
    },
    saveSessAndToDetail(shopId, member_onley_flag) {
      if (!this.$store.state.auth.loggedIn && member_onley_flag === '1') {
        this.$popup({
          text: '施設の詳細を表示するにはログインを行ってください。',
          url: this.$route.path,
          loginurl: this.facilityUrl(shopId),
        })
      } else {
        setSessionItem('PRE_SCREEN_ID', 'SU-01')
        this.$router.push({
          name: 'facility-detail',
          params: { id: shopId },
        })
      }
    },
    toNewPage(url) {
      // if(url.indexOf('http://') >= 0) {
      //   var newUrl = url.replace('http', 'https');
      //   window.open(newUrl, '_blank')
      // } else {
      window.open(url, '_blank')
      // }
    },
    allJapan() {
      window.dataLayer.push({
        event: '身近で使える優待施設',
        ap_screen_name: 'JAFナビ_身近で使える優待施設ボタン押下',
      })
      window.open('https://area.jaf.or.jp/membership/widearea')
    },
    requestGeneralNoticeData() {
      var general_Notices = {}
      var params = {}
      params.session_id = this.$store.state.auth.sessionId

      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      // 汎用お知らせAPI呼び出し
      this.$.post(API_GENERAL_NOTICE_LIST, formData)
        .then((response) => {
          // if (
          //   response.data.status_code === '00' &&
          //   response.data.general_notice &&
          //   response.data.general_notice[0]
          // ) {
          //   general_Notices.TITLE = response.data.general_notice[0].TITLE // タイトル
          //   general_Notices.NOTICE_CONTENT =
          //     response.data.general_notice[0].NOTICE_CONTENT // お知らせ内容(リンク文言)
          //   general_Notices.LINK_URL = response.data.general_notice[0].LINK_URL // リンクURL

          //   // 日付フォーマット変換、日本語曜日対応
          //   moment.locale('ja', {
          //     // weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
          //     weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
          //   })
          //   general_Notices.PUBLICATION_START_DATE = moment(
          //     response.data.general_notice[0].PUBLICATION_START_DATE
          //   ).format('YYYY/MM/DD(ddd)') // 掲載開始日
          // } else {
          //   general_Notices = {}
          // }

          this.generalNotices = response.data.general_notice;
          this.afterInit = true;
        })
        .catch(() => {})
    },
    bannerList() {
      if (
        !this.afterInit ||
        (this.banners[0] && Object.keys(this.banners[0]).length > 0)
      ) {
        return true
      } else {
        return false
      }
    },
    requestBannerData() {
      var params = {}
      params.session_id = this.$store.state.auth.sessionId

      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      // バナーAPI呼び出し
      this.$.post(API_BANNER_LIST, formData)
        .then((response) => {
          if (response.data.status_code === '00' && response.data.banner) {
            this.$nextTick(() => {
              this.banners = []
              this.banners.push(response.data.banner)
              this.getBanner()
            })
          } else {
            this.banners = []
          }

          this.afterInit = true
        })
        .catch(() => {})
    },
    formAccordionChange() {
      this.formAccordion = !this.formAccordion
    },
  },
  filters: {
    truncate: function(value, length, omission) {
      var length = length ? parseInt(length, 10) : 20
      var ommision = omission ? omission.toString() : '...'

      if (value.length <= length) {
        return value
      }

      return value.substring(0, length) + ommision
    },
  },
}
</script>

<template>
  <Layout>
    <div id="all_wrapper">
      <div id="app">
        <div v-if="isShowShotcut" id="shortcut_obi">
          <p id="shortcut_popup_open" class="message" @click="pwaModalOpen">
            ホーム画面にショートカットを追加しよう。
          </p>
          <p id="shortcut_obi_close" class="close" @click="pwaObiClose">
            <img src="@img/icon_72_close_wh.png" />
          </p>
        </div>
        <transition class="modal">
          <div
            v-if="pwaModalWindowFlg"
            id="shortcut_popup"
            @click="pwaModalClose"
          >
            <div class="modal_set" @click="stopEvent">
              <div class="modal_contents">
                <div class="modal_head">
                  <button class="modal_close" @click="pwaModalClose">
                    <img src="@img/icon_72_close.png" />
                  </button>
                </div>
                <div class="modal_inner">
                  <div v-if="uaType == 1" class="sentence ios">
                    <p class="message">
                      JAFナビで優待検索をより一層便利に使うため「ショートカットアイコン」を追加しよう。
                    </p>
                    <p class="img"><img src="@img/pwa/pwa_iOS_01.png"/></p>
                    <p class="img"><img src="@img/pwa/pwa_iOS_02.png"/></p>
                  </div>
                  <div v-if="uaType == 2" class="sentence android">
                    <p class="message">
                      JAFナビで優待検索をより一層便利に使うため「ショートカットアイコン」を追加しよう。
                    </p>
                    <p class="img"><img src="@img/pwa/pwa_android.jpeg"/></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div id="su01_contents">
          <!-- SU-02~05 -->
          <transition class="side_menu_anime menu">
            <div v-if="showMenu1" class="side_menu">
              <div class="one_top_subject">
                <div
                  v-if="isBackButtonDisp"
                  class="back_btn"
                  @click="backHandler"
                  ><span v-if="!isBackToHome" class="icon"
                    ><img src="@img/arrow_simple_32_L_navy.png"/></span
                  ><span>{{ backTitle }}</span
                  ><span v-if="isBackToHome" class="icon"
                    ><img src="@img/arrow_simple_32_R_navy.png"/></span
                ></div>
                <div class="subject_title">{{ menuCategory }}から探す</div>
              </div>
              <div
                v-for="(item, index) in showMenuList1"
                :class="item[1]"
                class="one_menu"
              >
                <div @click="selectViewMenu2(index, item[0])">
                  <span>{{ item[0] }}</span
                  ><span v-if="item[2]" class="icon"
                    ><img src="@img/arrow_simple_32_R_navy.png"/></span
                ></div>
              </div>
            </div>
          </transition>
          <transition class="side_menu_anime menu2">
            <div v-if="showMenu2" class="side_menu menu2">
              <div class="one_top_subject">
                <div
                  v-if="isBackButtonDisp"
                  class="back_btn"
                  @click="backHandler"
                  ><span v-if="!isBackToHome" class="icon"
                    ><img src="@img/arrow_simple_32_L_navy.png"/></span
                  ><span>{{ backTitle }}</span>
                  <span v-if="isBackToHome" class="icon"
                    ><img src="@img/arrow_simple_32_R_navy.png"/></span
                ></div>
                <div class="subject_title">{{ menuCategory }}から探す</div>
              </div>
              <div v-for="(item, index) in showMenuList2" class="one_menu">
                <div @click="selectViewMenu3(index, item[0])">
                  <span>{{ item[0] }}</span
                  ><span v-if="item[2]" class="icon"
                    ><img src="@img/arrow_simple_32_R_navy.png"/></span
                ></div>
              </div>
            </div>
          </transition>

          <div class="info_tag">
            <div class="content_limit_cover header_content">
              <a
                v-if="isBackButtonDisp"
                href="javascript:void(0);"
                class="back_btn"
                @click="backHandler"
              >
                <span v-if="!isBackToHome" class="icon"
                  ><img src="@img/arrow_simple_32_L_navy.png"
                /></span>
                <span>{{ backTitle }}</span>
                <span v-if="isBackToHome" class="icon"
                  ><img src="@img/arrow_simple_32_L_navy.png"
                /></span>
              </a>
              <div class="name"><p>優待施設を探す</p></div>
            </div>
          </div>

          <div
            v-if="displayMode != DISPLAYMODE.CONDITION && isBanner"
            class="top_banner_box"
          >
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, k) in banners[0]"
                  :id="item.LINK_URL"
                  class="swiper-slide"
                >
                  <img :src="item.BANNER_IMAGE" />
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div v-show="showArrow" class="prev_next_box">
              <div class="prev_next_inner">
                <div v-show="banners" class="swiper-button-prev">
                  <img src="@img/arrow_L.png" />
                </div>
                <div v-show="banners" class="swiper-button-next">
                  <img src="@img/arrow_R.png" />
                </div>
              </div>
            </div>
          </div>

          <div class="link_menu content_limit_cover">
            <!-- SP(768px以下の表示)　ここから -->
            <div class="sp_contents">
              <div v-for="(generalNotice,index) in generalNotices">
                <div
                  v-if="
                    Object.keys(generalNotices).length != 0 &&
                      displayMode != DISPLAYMODE.CONDITION
                  "
                  class="general_notice"
                >
                  <span class="notice">
                    <img src="@img/notice.png" />
                  </span>
                  <div class="notice_box">
                    <div>
                      <h4>
                        {{ generalNotice.TITLE | truncate }}
                      </h4>
                      <p v-if="generalNotice.LINK_URL.length != 0">
                        <a
                          href="javascript:void(0);"
                          @click="toNewPage(generalNotice.LINK_URL)"
                        >
                          {{ generalNotice.NOTICE_CONTENT }}
                        </a>
                      </p>
                      <p v-else>
                        {{ generalNotice.NOTICE_CONTENT }}
                      </p>
                      <span>{{ noticeStartDate(generalNotice.PUBLICATION_START_DATE) }}</span>
                    </div>

                  </div>
                </div>
              </div>

              <div
                v-if="displayMode != DISPLAYMODE.CONDITION"
                class="one_menu accordion"
                :class="{ on: formAreaAccordion }"
              >
                <div class="menu_head" @click="setAreaAccordion">
                  <span class="icon"><img src="@img/icon_48_pin2.png"/></span>
                  <span class="text">エリアから検索</span>
                  <span class="cursor"
                    ><img
                      v-if="formAreaAccordion"
                      src="@img/arrow_simple_32_U_navy.png"/>
                    <img v-else src="@img/arrow_simple_32_B_navy.png"
                  /></span>
                </div>
                <div
                  class="menu_contents contents"
                  :class="{ on: formAreaAccordion }"
                >
                  <div class="area_search_box">
                    <div class="search_way_box">
                      <div class="s_menu_btn">
                        <a class="one_menu" @click="toMap">
                          <label class="area">
                            <span class="icon"
                              ><img src="@img/icon_48_pin2_wh.png"
                            /></span>
                            <span class="text">現在地から検索する</span></label
                          >
                        </a></div
                      >
                      <div class="s_menu_btn">
                        <a class="one_menu" @click="allJapan">
                          <label class="area">
                            <span class="icon"
                              ><img src="@img/all_over_Japan.png"
                            /></span>
                            <span class="text"
                              >身近で使える優待施設</span
                            ></label
                          >
                        </a></div
                      >
                      <div class="s_menu_btn">
                        <a class="one_menu" @click="online">
                          <label class="area">
                            <span class="icon"
                              ><img src="@img/online_02.png"
                            /></span>
                            <span class="text">オンライン優待施設</span></label
                          >
                        </a>
                      </div>
                    </div>

                    <div class="s_area_btn">
                      <div
                        v-for="(areaMain, index) in areaButtonList"
                        :key="index"
                        :value="areaMain.option_list"
                        class="button"
                        @click="setArea(areaMain.option_list, true)"
                      >
                        <div class="area1">
                          {{ areaMain.option_list }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="displayMode != DISPLAYMODE.CONDITION"
                class="one_menu accordion"
                :class="{ on: formAccordion }"
              >
                <div
                  class="menu_head switch"
                  @click="formAccordionChange"
                >
                  <span class="icon"><img src="@img/icon_72_glass.png"/></span>
                  <span class="text">条件を指定して検索</span>
                  <span class="cursor">
                    <img
                      v-if="formAccordion"
                      src="@img/arrow_simple_32_U_navy.png"
                    />
                    <img v-else src="@img/arrow_simple_32_B_navy.png" />
                  </span>
                </div>
              </div>
              <div
                class="menu_contents contents"
                :class="{ on: formAccordion }"
              >
                <div class="contents_inner">
                  <form onsubmit="return false;">
                    <div class="input_area">
                      <div class="one_input left_icon key_word">
                        <input
                          v-model="searchWord"
                          type="text"
                          name=""
                          placeholder="キーワード"
                        />
                        <img class="glass" src="@img/icon_72_glass.png" />
                      </div>
                      <div class="one_button" @click="selectViewMenu('genre')">
                        <div class="text" :class="{ selected: genreSelected }">
                          <span class="icon"
                            ><img src="@img/icon_72_genre.png"
                          /></span>
                          <!-- <span class="name">{{ menuCategoryGenre }}</span> -->
                          <span
                            v-if="selectedGenre"
                            :class="['name', 'saoNowrap']"
                            style="color: black"
                            >{{ searchFormInfo.genre }}</span
                          >
                          <span
                            v-if="!selectedGenre"
                            :class="['name', 'saoNowrap']"
                            >ジャンル</span
                          >
                        </div>
                        <div class="arrow">
                          <img src="@img/arrow_simple_32_R_navy.png" />
                        </div>
                      </div>
                      <div
                        :class="[
                          'one_button',
                          isOnline ? 'is_online_disable' : '',
													'one_button_area',
                        ]"
                        @click="selectViewMenu('area')"
                      >
												<div class="area_arrow_box">
	                        <div class="text" :class="{ selected: areaSelected }">
	                          <span class="icon size_mini"
	                            ><img src="@img/icon_48_pin.png"
	                          /></span>
	                          <!-- <span class="name">{{ menuCategoryArea }}</span> -->
	                          <span
	                            v-if="selectedArea"
	                            :class="['name', 'saoNowrap']"
	                            style="color: black"
	                            >{{ searchFormInfo.area }}</span
	                          >
	                          <span
	                            v-if="!selectedArea"
	                            :class="['name', 'saoNowrap']"
	                            >エリア</span
	                          >
	                        </div>
													<div class="arrow">
	                          <img :class="showAreaSelectList ? 'arrow_down' : ''" src="@img/arrow_simple_32_R_navy.png" />
	                        </div>
												</div>
	                      <ul v-show="showAreaSelectList">
	                        <li @click="goArea">エリアから選びなおす</li>
	                        <li @click="goPref">都道府県から選びなおす</li>
	                        <li v-show="showAreaMunSelectList" @click="goMun">市区町村から選びなおす</li>
	                      </ul>
											</div>
										<div class="area_banner">&nbsp;1</div>
										</div>

                    <div class="toggle_area toggle_area_sp">
                      <div class="set_toggle">
                        <div>
                          <p>アプリクーポン</p>
                        </div>
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="existCoupon"
                              class="checkbox-input"
                              type="checkbox"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div>
                          <p>特別優待</p>
                        </div>
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="isLimited"
                              class="checkbox-input"
                              type="checkbox"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div>
                          <p>オンライン優待</p>
                        </div>
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="isOnline"
                              class="checkbox-input"
                              type="checkbox"
                              @change="clearArea"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                      </div>
                      <div class="online_message_mobile">
                        <p>※オンライン優待は検索結果一覧のみ</p>
                      </div>
                      <div class="set_toggle">
                        <div>
                          <p>新規優待施設</p>
                        </div>
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="isNewShop"
                              class="checkbox-input"
                              type="checkbox"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div>
                          <p :style="isDisableInputExcludeBrandFlag ? 'color: #848484' : ''">チェーン店を除く</p>
                        </div>
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="localExcludeBrandFlag"
                              class="checkbox-input"
                              type="checkbox"
                              :disabled="isDisableInputExcludeBrandFlag"
                            />
                            <div :class="'checkbox-parts ' + (isDisableInputExcludeBrandFlag ? 'disable-checkbox-parts' : '')"></div>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="decide">
                      <input
                        id="submit_btn"
                        type="button"
                        value="この条件で検索する"
                        @click="shopSearch"
                      />
                      <label class="submit" for="submit_btn"
                        ><span class="icon"
                          ><img src="@img/icon_72_search_wh.png"/></span
                        ><span class="text">この条件で検索する</span></label
                      >
                      <input
                        type="reset"
                        value="条件クリア"
                        class="bold"
                        @click="formClear"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- SP(768px以下の表示)　ここまで -->
            <!-- PC(768px以上の表示)　ここから -->
            <div class="pc_contents">
              <div v-if="displayMode != DISPLAYMODE.CONDITION" class="one_menu">
                <div v-for="(generalNotice,index) in generalNotices">
                  <div
                    v-if="
                      Object.keys(generalNotices).length != 0 &&
                        displayMode != DISPLAYMODE.CONDITION
                    "
                    class="general_notice"
                  >
                    <span class="notice">
                      <img src="@img/notice.png" />
                    </span>
                    <div class="notice_box">
                      <div>
                        <h4>
                          {{ generalNotice.TITLE | truncate }}
                        </h4>
                        <p v-if="generalNotice.LINK_URL.length != 0">
                          <a
                            href="javascript:void(0);"
                            @click="toNewPage(generalNotice.LINK_URL)"
                          >
                            {{ generalNotice.NOTICE_CONTENT }}
                          </a>
                        </p>
                        <p v-else>
                          {{ generalNotice.NOTICE_CONTENT }}
                        </p>
                        <span>{{ noticeStartDate(generalNotice.PUBLICATION_START_DATE) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="menu_head area_title_head">
                  <span class="icon"><img src="@img/icon_48_pin2.png"/></span>
                  <span class="text">エリアから検索</span>
                </div>
                <div class="menu_btn">
                  <div
                    class="area_btn_box"
                    style="cursor:pointer"
                    @click="toMap"
                  >
                    <span class="icon"
                      ><img src="@img/icon_48_pin2_wh.png"
                    /></span>
                    <span class="text">現在地から検索する</span>
                  </div>
                  <div
                    class="area_btn_box"
                    style="cursor:pointer"
                    @click="allJapan"
                  >
                    <span class="icon"
                      ><img src="@img/all_over_Japan.png"
                    /></span>
                    <span class="text">身近で使える優待施設</span>
                  </div>
                  <div
                    class="area_btn_box"
                    style="cursor:pointer"
                    @click="online"
                  >
                    <span class="icon"><img src="@img/online_02.png"/></span>
                    <span class="text">オンライン優待施設</span>
                  </div>
                </div>
                <div class="area_btn">
                  <div
                    v-for="(areaMain, index) in areaMenuList"
                    :key="index"
                    :value="areaMain.option_list"
                    class="button"
                    @click="setArea(areaMain.option_list, true)"
                  >
                    <!-- <div v-if="areaMain.option_list !== '指定しない' && areaMain.option_list !== '現在地周辺'" class="area1">
                      {{ areaMain.option_list }}
                    </div> -->
                    <div
                      v-if="
                        areaMain.option_list === '北海道' ||
                          areaMain.option_list === '東北' ||
                          areaMain.option_list === '関東甲信越' ||
                          areaMain.option_list === '東海・北陸'
                      "
                      class="area1"
                    >
                      {{ areaMain.option_list }}
                    </div>
                  </div>
                  <div class="area_btn">
                    <div
                      v-for="(areaMain, index) in areaMenuList"
                      :key="index"
                      :value="areaMain.option_list"
                      class="button"
                      @click="setArea(areaMain.option_list, true)"
                    >
                      <div
                        v-if="
                          areaMain.option_list === '近畿' ||
                            areaMain.option_list === '中国' ||
                            areaMain.option_list === '四国' ||
                            areaMain.option_list === '九州・沖縄'
                        "
                        class="area1"
                      >
                        {{ areaMain.option_list }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="one_menu">
                <div
                  class="menu_head switch"
                  @click="formAccordionChange"
                >
                  <span class="icon"><img src="@img/icon_72_glass.png"/></span>
                  <span class="text">条件を指定して検索</span>
                </div>
              </div>

              <div class="menu_contents contents on">
                <div class="contents_inner">
                  <form onsubmit="return false;">
                    <div class="input_area">
                      <div class="one_input left_icon">
                        <input
                          v-model="searchWord"
                          type="text"
                          name=""
                          class="modify_vertical_align"
                          placeholder="キーワード"
                        />
                        <img src="@img/icon_72_glass.png" />
                      </div>
                      <div class="select_area">
                        <div class="select_set">
                          <div class="one_select main">
                            <p class="icon">
                              <img src="@img/icon_72_genre.png" />
                            </p>
                            <select
                              v-model="pcSelectGanreMain"
                              :class="{
                                selected_on: pcSelectGanreMain,
                                edge_padding: isEdge,
                              }"
                              placeholder="ジャンル"
                              @change="setSubgenre"
                            >
                              <option value="" disabled selected hidden
                                >ジャンル</option
                              >
                              <option
                                v-for="(genreMain, index) in genreMenuList"
                                :key="index"
                                :value="genreMain.code"
                                >{{ genreMain.name }}</option
                              >
                            </select>
                          </div>
                          <div class="one_select sub">
                            <select
                              v-model="pcSelectGanreSub"
                              :class="{
                                selected_on: pcSelectGanreSub,
                                edge_padding: isEdge,
                              }"
                              :disabled="pcGanreSubDisabled"
                              @change="saveSubgenre"
                            >
                              <option value="すべて" class="no_select" selected
                                >すべて</option
                              >
                              <option
                                v-for="(genreSub, index) in genreSubMenuList"
                                :key="index"
                                :value="genreSub.subGenreCode"
                                >{{ genreSub.subGenreName }}</option
                              >
                            </select>
                          </div>
                        </div>
											</div>
											<div class="select_area">
                        <div class="select_set">
                          <div class="one_select main">
                            <p class="icon mini_size">
                              <img src="@img/icon_48_pin.png" />
                            </p>
                            <select
                              v-model="pcSelectAreaMain"
                              :class="{
                                selected_on: mainAreaSelectCss,
                                edge_padding: isEdge,
                              }"
                              placeholder="エリア"
                              :disabled="isOnline"
                              @change="setSubArea"
                            >
                              <option
                                value=""
                                disabled
                                selected
                                :hidden="!isOnline"
                                >{{ areaPlaceholder }}</option
                              >
                              <option
                                v-for="(areaMain, index) in areaMenuList"
                                :key="index"
                                :value="areaMain.option_list"
                                >{{ areaMain.option_list }}</option
                              >
                            </select>
                          </div>
													<div class="one_select sub">
                            <select
                              v-model="pcSelectAreaSub"
                              :class="{
                                selected_on: pcSelectAreaSub,
                                edge_padding: isEdge,
                              }"
                              :disabled="pcAreaSubDisabled || isOnline"
                              @change="saveSubArea"
                            >
                              <option value="すべて" class="no_select" selected
                                >すべて</option
                              >
                              <option
                                v-for="(areaSub, index) in areaSubMenuList"
                                :key="index"
                                :value="areaSub.option_list"
                                >{{ areaSub.option_list }}</option
                              >
                            </select>
                          </div>
													<div class="one_select mun">
                            <select
                              v-model="pcSelectAreaMun"
                              :class="{
                                selected_on: pcSelectAreaMun,
                                edge_padding: isEdge,
                              }"
                              :disabled="pcAreaMunDisabled || isOnline"
                              @change="saveMunArea"
                            >
                              <option
                                v-for="(areaMun, index) in areaMunMenuList"
                                :key="index"
                                :value="areaMun"
                                >{{ areaMun }}</option
                              >
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="toggle_area">
                      <div class="set_toggle">
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="existCoupon"
                              class="checkbox-input"
                              type="checkbox"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                        <div>
                          <p>アプリクーポン</p>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="isLimited"
                              class="checkbox-input"
                              type="checkbox"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                        <div>
                          <p>特別優待</p>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="isOnline"
                              class="checkbox-input"
                              type="checkbox"
                              @change="clearArea"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                        <div>
                          <p>オンライン優待</p>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="isNewShop"
                              class="checkbox-input"
                              type="checkbox"
                            />
                            <div class="checkbox-parts"></div>
                          </label>
                        </div>
                        <div>
                          <p>新規優待施設</p>
                        </div>
                      </div>
                      <div class="set_toggle">
                        <div class="can-toggle">
                          <label class="check_area">
                            <input
                              v-model="localExcludeBrandFlag"
                              class="checkbox-input"
                              type="checkbox"
                              :disabled="isDisableInputExcludeBrandFlag"
                            />
                            <div :class="'checkbox-parts ' + (isDisableInputExcludeBrandFlag ? 'disable-checkbox-parts' : '')"></div>
                          </label>
                        </div>
                        <div>
                          <p :style="isDisableInputExcludeBrandFlag ? 'color: #848484' : ''">チェーン店を除く</p>
                        </div>
                      </div>
                    </div>
                    <div class="online_message_pc">
                      <p>※オンライン優待は検索結果一覧のみ</p>
                    </div>

                    <div class="decide">
                      <input
                        id="submit_btn"
                        type="button"
                        value="この条件で検索する"
                      />
                      <label class="submit" for="submit_btn"
                        ><span class="icon"
                          ><img src="@img/icon_72_search_wh.png"/></span
                        ><span class="text">この条件で検索する</span></label
                      >
                      <input
                        type="reset"
                        value="条件クリア"
                        class="bold"
                        @click="formClear"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <h4
              v-if="
                shopldShowRecomendList() && displayMode != DISPLAYMODE.CONDITION
              "
              class="shop_info_tile"
            >
              <span>
                <img src="@img/recommend.png" />
              </span>
              おすすめ施設
            </h4>
            <ul
              v-if="
                shopldShowRecomendList() && displayMode != DISPLAYMODE.CONDITION
              "
              id="shop_info"
              class="shop_info"
            >
              <li v-for="(item, itemIndex) in shopRecomendResult">
                <div class="type_single">
                  <a
                    href="javascript:void(0);"
                    @click="
                      saveSessAndToDetail(
                        item.FACILITIES_ID || item.SHISETU_ID,
                        item.MENBER_ONLY_FLAG,
                      )
                    "
                  >
                    <h4>{{ item.MEISYO || item.NAME }}</h4>
                    <div class="content_inner">
                      <div class="photo_area">
                        <div>
                          <img
                            :src="combineUrl(item.PHOTO1)"
                            :onerror="defaultAvatar"
                            loading="lazy"
                          />
                        </div>
                      </div>
                      <div class="sentence_area">
                        <p
                          v-show="item.WEB_FLAG != 1 && item.DISTANCE != ''"
                          class="distance"
                        >
                          <span><img src="@img/icon_48_pin.png"/></span>
                          <span> 現在地から{{ item.DISTANCE }} </span>
                        </p>
                        <p
                          v-if="item.TOKUBETU_FLAG == 1 || item.COUPON == 1"
                          v-show="item.WB_NAIYO1"
                          class="service_toku"
                        >
                          <span><img src="@img/icon_48_en.png"/></span>
                          <span>{{ discount(item) }}</span>
                        </p>
                        <p v-else v-show="item.WB_NAIYO1" class="service">
                          <span><img src="@img/icon_48_en.png"/></span>
                          <span>{{ discount(item) }}</span>
                        </p>
                        <div
                          v-if="item.PREMIAM_FLAG == 1 && !item.WB_NAIYO1 && !item.TOKUBETU_NAIYOU && item.COUPON != 1"
                          class="only_premiam"
                        >
                          <p class="distance">
                            <span class="icon"><img class="toku" src="@img/period_premium.png"/></span>
                            <span class="tokubetu">プレミアム優待</span>
                          </p>
                          <p class="naiyou" >
                            <span>10年以上ご継続いただいている個人会員の方限定の優待実施中です。</span>
                          </p>
                        </div>
                        <div
                              v-else-if="item.COUPON == 1">
                              <p
                                class="distance"
                                ><span class="icon"
                                  ><img class="ap_cou" src="@img/icon_cassette_coupon.png"
                                /></span>
                                <span class="ap_coupon"
                                  >アプリクーポン</span
                                ></p
                              >
                              <p v-if="showCouponLogin"
                                class="coupon_naiyou"
                                ><span>ログインのうえご確認ください。ご利用にはJAFアプリのインストールが必要です。</span
                              ></p>
                              <p v-else-if="item.COUPON_SUMMARY"
                                class="coupon_naiyou"
                                ><span v-html="item.COUPON_SUMMARY.replace(/(\\r)*\\n/g, '<br>')"></span
                              ></p>
                            </div>
                        <div
                          v-else-if="item.TOKUBETU_FLAG == 1 && item.COUPON != 1" >
                          <p class="distance"
                            ><span class="icon"
                              ><img class="toku" src="@img/period.png"
                            /></span>
                            <span class="tokubetu">特別優待</span></p
                          >
                          <p class="naiyou"
                            ><span v-html="item.TOKUBETU_NAIYOU"></span
                          ></p>
                        </div>
                      </div>
                    </div>
                    <div class="tag_list">
                      <p v-if="item.COUPON == 1" class="one_tag tag_app">
                        <span>アプリクーポン</span>
                      </p>
                      <p
                        v-if="item.TOKUBETU_FLAG == 1"
                        class="one_tag tag_limited"
                      >
                        <span>特別優待</span>
                      </p>
                      <p v-if="item.WEB_FLAG == 1" class="one_tag tag_online">
                        <span>オンライン優待</span>
                      </p>
                      <p
                        v-if="item.PREMIAM_FLAG == 1"
                        class="one_tag tag_premium"
                      >
                        <span>プレミアム優待</span>
                      </p>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
            <!-- PC(768px以上の表示)　ここまで -->
            <!-- 優待開始・終了のお知らせ -->
            <!--
              todo Kego 本番リリースする前必ず戻る必要
              <div v-if="displayMode != DISPLAYMODE.CONDITION && false" class="new_old_box">
              開発と画面確認の場合、新規終了優待一覧画面の確認ための一時対応
              <div v-if="displayMode != DISPLAYMODE.CONDITION " class="new_old_box">
            -->
            <div v-if="displayMode != DISPLAYMODE.CONDITION" class="new_old_box">
              <div class="title_box">
                <img src="@img/icon_72_genre.png" alt="優待開始・終了アイコン"/>
                <span>優待開始・終了のお知らせ</span>
              </div>
              <div class="link_box">
                <p @click="goNewOld(1)">▶ 新規優待施設</p>
                <p @click="goNewOld(9)">▶ 優待終了施設</p>
              </div>
            </div>
          </div>
          <form id="ssnIdPostForm" name="ssnIdForm" action="" method="POST" target="_blank"></form>
        </div>
      </div>
    </div>
    <Footer />
    <Loading
      ref="heightLoading"
      :active="isHeightLoading"
      color="#070141"
      loader="bars"
      :opacity="1"
      :can-cancel="false"
      :is-full-page="false"
    ></Loading>
  </Layout>
</template>
<style lang="scss" src="@assets/css/SU-01.scss" scoped></style>
<style lang="scss">
@import '@assets/css/su_common.scss';
</style>
<style scoped>
@media (max-width: 768px) {
}
</style>
